import { Module } from 'vuex';
import IRootState from '@/store/types/IRootState';
import IHomeState from './types/IHomeState';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const home: Module<IHomeState, IRootState> = {
  namespaced: true,
  state: {
    meta: {
      title: '',
      description: '',
    },
    slider: {
      slides: [],
    },
    statistics: {
      title: '',
      subtitle: '',
      statistics: [],
    },
    covid19: {
      title: '',
      description: '',
      images: [],
    },
  },
  actions,
  getters,
  mutations,
};

export default home;
